import { Box, Center, Heading, Text, Stack, Avatar, useColorModeValue, Image} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const PostCard = (props) => {

  const { date, image, title, avatar, name } = props;

  var d = new Date(date);
  var now = Date.now();

  const elapsedDays = Math.floor( (now - d) / (1000 * 60 * 60 * 24) );
  const elapsedHours = Math.floor( ( now -d) / 36e5);
  const elapsedMinutes = Math.floor(((  (now - d ) % 86400000) % 3600000) / 60000);
  
  const { t } = useTranslation();

  return (
    <Center py={6} {...props}>
      <Box maxW={'445px'} w={'full'} bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'} rounded={'md'} p={6} overflow={'hidden'}>
        
        <Box overflow="hidden" 
            h={'210px'} bg={'gray.100'} mt={-6} mx={-6} mb={6} pos={'relative'}>

          <Image src={image} layout={'fill'} maxWidth="100%" />

        </Box>

        <Stack>
          <Text color={'green.500'} textTransform={'uppercase'} fontWeight={800}
            fontSize={'sm'} letterSpacing={1.1}>
            Evento
          </Text>

          <Heading
            color={useColorModeValue('gray.700', 'white')} fontSize={'2xl'} fontFamily={'body'}>
            { title }
          </Heading>

          { props.content &&
            <Text color={'gray.500'}>
              { props.content }
            </Text>
          }

        </Stack>

        <Stack mt={6} direction={'row'} spacing={4} align={'center'}>
          
          <Avatar src={avatar} alt={'Author'} />
          <Stack direction={'column'} spacing={0} fontSize={'sm'}>
            <Text fontWeight={600}>{name}</Text>
            <Text color={'gray.500'}>
              { elapsedDays > 0 ? elapsedDays + ' ' + t("daysAgo") : elapsedHours > 0 ? elapsedHours + ' ' + t("hoursAgo") : elapsedMinutes + ' ' + t("minutesAgo") }
            </Text>
          </Stack>

        </Stack>

      </Box>
    </Center>
  );
}

export default PostCard;